export default {
  loader: false,
  token: localStorage.getItem("escsid") || "",
  notifications: [],
  user: [],
  page: {},
  ads: [],
};
